import { render, staticRenderFns } from "./AccessoEPermessi.vue?vue&type=template&id=82469970&scoped=true"
import script from "./AccessoEPermessi.vue?vue&type=script&lang=js"
export * from "./AccessoEPermessi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82469970",
  null
  
)

export default component.exports